import {callsApi} from './api';
import CallActions from 'actions/CallActions';

const interceptResponse = (response, action, args) => {
  if (action === CallActions.searchSuccess || action === CallActions.searchError) {
    return {args, response};
  } else {
    return response;
  }
};

/**
 * Interactions with /search api
 */
const SearchSource = {
  // Text search
  textSearch: {
    remote(state, searchTerm, limit, page, sortByDate = false) {
      if (!searchTerm) {
        searchTerm = '';
      }
      let body = {
        limit: limit,
        page: page || 1,
        term: searchTerm.trim().replace(/\s+/g, ' '),
        sort_by_date: sortByDate,
      };
      return callsApi.post('/search', body);
    },
    interceptResponse: interceptResponse,
    success: CallActions.searchSuccess,
    error: CallActions.searchError,
  },

  // Search with fields
  fieldsSearch: {
    /**
     * Post to the search endpoint.
     *
     * @param  {string} term   A search term
     * @param  {object} fields An object specifying the fields restriction used for the search
     * @param  {int} limit  Limit the total number of items to return
     * @param  {int} page   Index of the page to return
     * @param  {immutable.Map} state  State of the calling store
     */
    remote(state, term, fields, limit, page, sortByDate = false) {
      let body = {
        term: term.trim().replace(/\s+/g, ' '),
        fields: fields,
        limit: limit,
        page: page || 1,
        sort_by_date: sortByDate,
      };
      return callsApi.post('/search', body);
    },
    interceptResponse: interceptResponse,
    error: CallActions.searchError,
    success: CallActions.searchSuccess,
  },
};

export default SearchSource;
